import React from "react";

const COLORS = [
  "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
  "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ac",
  "#86bcb6", "#d37295", "#a0cbe8", "#ffbe7d", "#8cd17d",
];

function arcPath(cx, cy, r, startAngle, endAngle) {
  const start = {
    x: cx + r * Math.cos(startAngle),
    y: cy + r * Math.sin(startAngle),
  };
  const end = {
    x: cx + r * Math.cos(endAngle),
    y: cy + r * Math.sin(endAngle),
  };
  const largeArc = endAngle - startAngle > Math.PI ? 1 : 0;
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`;
}

// Sharesight-style "Diversity" donut: share of portfolio market value per
// holding. Mixed-currency portfolios are charted on raw values per holding
// (an approximation until FX conversion is supported).
export function DiversityChart({ rows }) {
  const valued = (rows || [])
    .filter((r) => r.value !== null && r.value !== undefined && r.value > 0)
    .sort((a, b) => b.value - a.value);

  const total = valued.reduce((sum, r) => sum + r.value, 0);
  if (valued.length === 0 || total <= 0) return null;

  const cx = 80, cy = 80, r = 60, strokeWidth = 28;
  let angle = -Math.PI / 2;
  const segments = valued.map((row, i) => {
    const fraction = row.value / total;
    const start = angle;
    // Cap just under a full circle so single-holding portfolios still draw.
    const sweep = Math.min(fraction * 2 * Math.PI, 2 * Math.PI - 0.0001);
    angle += fraction * 2 * Math.PI;
    return {
      ticker: row.ticker,
      pct: fraction * 100,
      color: COLORS[i % COLORS.length],
      d: arcPath(cx, cy, r, start, start + sweep),
    };
  });

  return (
    <div className="card mb-3" data-testid="diversity-chart">
      <div className="card-header fw-bold">Diversity</div>
      <div className="card-body d-flex flex-wrap align-items-center">
        <svg width="160" height="160" viewBox="0 0 160 160" role="img" aria-label="Portfolio allocation chart">
          {segments.map((seg) => (
            <path
              key={seg.ticker}
              d={seg.d}
              fill="none"
              stroke={seg.color}
              strokeWidth={strokeWidth}
            >
              <title>{`${seg.ticker}: ${seg.pct.toFixed(1)}%`}</title>
            </path>
          ))}
        </svg>
        <ul className="list-unstyled ms-4 mb-0" style={{ columnCount: valued.length > 8 ? 2 : 1 }}>
          {segments.map((seg) => (
            <li key={seg.ticker}>
              <span
                style={{
                  display: "inline-block",
                  width: 12,
                  height: 12,
                  backgroundColor: seg.color,
                  marginRight: 6,
                  borderRadius: 2,
                }}
              />
              {seg.ticker} — {seg.pct.toFixed(1)}%
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
